import { withTranslations } from '@/utils/Language';
import modalsEn from '@/assets/i18n/modals/en.json';
import formsEn from '@/assets/i18n/forms/en.json';
import samlEn from '@/assets/i18n/features/saml/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...modalsEn, ...formsEn, ...samlEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/modals/${lang}.json`),
      import(`@/assets/i18n/forms/${lang}.json`),
      import(`@/assets/i18n/features/saml/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([modals, forms, saml, ui, languages, languagesTranslated]) => ({
      ...modals.default,
      ...forms.default,
      ...saml.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
